export default __webpack_public_path__ + "static/media/Footer_Home@2x.3d04e456.png";